import React from 'react';
import Typography from '@mui/material/Typography';
import Link from '../../../../elements/Link';
import { StyledGroupPLLinks, StyledPLLinks } from './styles';

const FooterPL = () => {
  return (
    <StyledPLLinks>
      <StyledGroupPLLinks>
        <Typography component="p" variant="DS_copyMediumRegular">
          Informacje o leczeniu
        </Typography>
        <ul>
          <li>
            <Link url="/">
              <Typography component="span" variant="DS_copySmallBold">
                Pełne informacje o procesie i leczeniu DR SMILE
              </Typography>
            </Link>
          </li>
        </ul>
      </StyledGroupPLLinks>
      <StyledGroupPLLinks>
        <Typography component="p" variant="DS_copyMediumRegular">
          O firmie
        </Typography>
        <ul>
          <li>
            <Link url="/drsmilepolska/">
              <Typography component="span" variant="DS_copySmallBold">
                DrSmile Polska
              </Typography>
            </Link>
          </li>
          <li>
            <Link url="/legal/danefirmy/">
              <Typography component="span" variant="DS_copySmallBold">
                Dane firmy
              </Typography>
            </Link>
          </li>
          <li>
            <Link url="https://dr-smile.jobs.personio.de/">
              <Typography component="span" variant="DS_copySmallBold">
                Kariera
              </Typography>
            </Link>
          </li>
        </ul>
      </StyledGroupPLLinks>
      <StyledGroupPLLinks>
        <Typography component="p" variant="DS_copyMediumRegular">
          Kontakt
        </Typography>
        <ul>
          <li>
            <Link url="https://drsmile.zendesk.com/hc/pl/">
              <Typography component="span" variant="DS_copySmallBold">
                Pytania i odpowiedzi / Czat na żywo
              </Typography>
            </Link>
          </li>
          <li>
            <Typography
              component="a"
              href="mailto:customer@drsmile.pl"
              aria-label="Email"
              target="_self"
              variant="DS_copySmallBold"
            >
              customer@drsmile.pl
            </Typography>
          </li>
          <li>
            <li>
              <Typography
                component="a"
                href="tel:+48223075187"
                aria-label="Phone"
                target="_self"
                rel=""
                variant="DS_copySmallBold"
              >
                +48 22 307 51 87 <span>(Pon.-Pt. 8:00-17:30)</span>
              </Typography>
            </li>
          </li>

          <li>
            <Link url="/media/">
              <Typography component="span" variant="DS_copySmallBold">
                Media
              </Typography>
            </Link>
          </li>
        </ul>
      </StyledGroupPLLinks>
    </StyledPLLinks>
  );
};

export default FooterPL;
